<template>
  <div class="box">
    <div class="box-left">
      <my-form
        v-model="form"
        autocomplete="off"
        label-width="80px"
        @submit="submitHandler"
      >
        <el-form-item
          label="投资估价"
          prop="costlimit"
          :rules="newRule('投资估价', 'required')"
        >
          <el-input
            class="login-input"
            v-model="form.costlimit"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            clearable
            autocomplete="off"
            :placeholder="`请输入投资估价`"
          >
            <template slot="append">万元</template>
          </el-input>
        </el-form-item>

        <el-form-item
          label="设置行业"
          prop="industryId"
          :rules="newRule('行业', 'required')"
        >
          <el-select
            v-model="form.industryId"
            clearable
            placeholder="请选择"
            class="select"
            @change="radioChange"
          >
            <el-option
              v-for="item in options"
              :key="item.industryid"
              :label="item.industryname"
              :value="item.industryid"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <span class="coefficient">行业调整系数:{{ form.industryratio }}</span>

        <el-form-item label="折扣" prop="discount" :rules="newRule('折扣', 'required')">
          <el-input
            class="login-input"
            v-model="form.discount"
            @change="discountHandler"
            clearable
            type="number"
            min="0"
            autocomplete="off"
            :placeholder="`请输入折扣`"
          >
            <template slot="append">%</template>
          </el-input>
        </el-form-item>

        <template slot="btn" slot-scope="scope">
          <div class="btn-login">
            <el-button type="primary" @click="scope.submitHandler">
              开始计算
            </el-button>
          </div>
        </template>
      </my-form>
    </div>

    <div class="box-right">
        <el-table
          class="table-res"
          :data="tableData"
          border
          style="width: 100%"
          v-loading="tableLoading"
        >
          <el-table-column prop="content" label="工作内容" min-width="180"> </el-table-column>
          <el-table-column prop="num" label="金额：万元" width="220"> </el-table-column>
        </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        costlimit: "", //估价
        industryratio: "", //行业
        discount: 100, //折扣
        industryId: "",
      },
      options: [],
      tableData: [
        {
          content: "一、编制项目建议书",
          num: "0.00",
        },
        {
          content: "二、编制可行性研究报告",
          num: "0.00",
        },
        {
          content: "三、评估项目建议书",
          num: "0.00",
        },
        {
          content: "四、评估可研报告",
          num: "0.00",
        },
      ],
      tableLoading: false, //表格loading
    };
  },
  methods: {
    submitHandler() {
      this.tableLoading = true;
      this.$get(
        `${this.$store.state.api.webUrl}/navigation/getCalculateData.json`,
        {
          costlimit: this.form.costlimit,
          industryratio: this.form.industryratio,
          discount: this.form.discount,
          type: "TYPE1",
        },
        (data) => {
          const arr = [data];
          for (let i in data) {
            arr.push(data[i]);
          }
          for (let index = 0; index < this.tableData.length; index++) {
            this.tableData[index].num = arr[index + 1];
          }
          this.tableLoading = false;
        }
      );
      this.$emit("startCompute");
    },
    /**
     * 折扣输入框 change 事件
     */
    discountHandler() {
      if (this.form.discount < 0) {
        this.form.discount = 0;
      } else {
        let discountStr = String(this.form.discount)
        discountStr = discountStr.replace(/[^\d.]/g, "")
          .replace(/^0\d+|^\./g, "")
          .replace(/\.{2,}/g, ".")
          .replace(".", "$#$")
          .replace(/\./g, "")
          .replace("$#$", ".")
          .replace(/^(\d+)\.(\d\d).*$/, "$1.$2");
        this.form.discount = parseFloat(discountStr) || 0;
      }
    },
    /**
     * 获取数据
     */
    queryData() {
      this.$get(
        `${this.$store.state.api.webUrl}/navigation/getConsultList.json`,
        (data) => {
          this.options = data;
        }
      );
    },
    radioChange(id) {
      this.form.industryratio = this.options.filter((e) => {
        return e.industryid == id;
      })[0].ratio;
    },
  },
  mounted() {
    this.queryData();
  },
};
</script>

<style lang="scss" scoped>
@import "../style/main.scss";

.box {
  width: 100%;
  box-sizing: border-box;
  .coefficient {
    display: block;
    margin-top: -6px;
    margin-left: 80px;
    margin-bottom: 24px;
    color: #606266;
  }
  .select {
    width: 100%;
  }

  .btn-login {
    display: flex;
    justify-content: center;
  }
}
.box > div {
  float: left;
  width: 400px;
}

.box-right {
  width: 520px !important;
  margin-top: -55px;
  margin-left: 100px;
}
</style>
